import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import RecentHighlights from './RecentHighlights';
import { styled } from '@mui/material/styles';

function ActivityPanel() {
  return (
    <Box pb={1}>
      <ActivityTitle as="h3">Recent Highlights</ActivityTitle>
      <RecentHighlights />
    </Box>
  );
}

const ActivityTitle = styled(Typography, { label: 'ActivityTitle' })(({ theme }) => ({
  color: theme.palette.custom.yellowishBrown,
  fontSize: 16,
  margin: 0,
}));

export default memo(ActivityPanel);
